import _ from 'lodash'
import SEMICONDUCTORS_SEARCH_CONFIG from './config'
import axios from 'axios'
import API_PROGRESS from '../../core/api-progress'
import API_HINT from '../../core/api-hint'

class SemiconductorsSearch {
    constructor() {
        this.DOM = {
            form: SEMICONDUCTORS_SEARCH_CONFIG.form
        }

        this.diodesJson = null
        this.thyristorJson = null
        this.diodesUrl = null
        this.thyristorsUrl = null
        this.noresults = null

        this.DOM.form ? this.init() : null
    }

    init () {
        this.values()
        this.listeners()
        console.log(this)
    }

    values() {
        this.diodesJson = SEMICONDUCTORS_SEARCH_CONFIG.diodesJSON.value,
        this.thyristorsJson = SEMICONDUCTORS_SEARCH_CONFIG.thyristorsJSON.value,
        this.diodesUrl = SEMICONDUCTORS_SEARCH_CONFIG.diodesUrl.value,
        this.thyristorsUrl = SEMICONDUCTORS_SEARCH_CONFIG.thyristorsUrl.value
        this.noresults = this.DOM.form.getAttribute('data-noresults')
    }

    listeners () {
        this.DOM.form.addEventListener('submit', this.submit.bind(this))
    }

    submit () {
        event.preventDefault()
        API_PROGRESS._loading( this.DOM.form )
        const formData = _.select('input[name="search"]', this.DOM.form).value.toUpperCase()
        axios.get(this.diodesJson)
        .then((response) => {
            
            
            const diodes = response.data
            console.log(response)
            let results = diodes.filter(el => el['Part number'].toUpperCase().includes(formData))
            if (results.length > 0) {
                window.location.replace(`${this.diodesUrl}?s=${formData}`)
            } else {
                axios.get(this.thyristorsJson)
                .then((response) => {
                    
                    const thyristors = response.data
                    let results = thyristors.filter(el => el['Part number'].toUpperCase().includes(formData))
                    if (results.length > 0) {
                        window.location.replace(`${this.thyristorsUrl}?s=${formData}`)
                    } else {
                        // Show no results
                        API_HINT._open( 'is--error', this.noresults )
                        setTimeout(() => {
                            API_HINT._close()
                        }, 3000)
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
                .then(() => {
                    API_PROGRESS._loaded( this.DOM.form )
                })
            }
        })
        .catch((error) => {
            console.log(error)
        })
        .then(() => {
            API_PROGRESS._loaded( this.DOM.form )
        })
        
    }
}

const SEMICONDUCTORS_SEARCH = new SemiconductorsSearch()
export default SEMICONDUCTORS_SEARCH